import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of as observableOf, Observable } from 'rxjs';
import { ErrorResponse, SuccessResponse } from '../../response';
import { ActivityFilter, IActivityLogs } from '../library-service/library-model';

@Injectable({ providedIn: 'root' })
export class SurveyService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${SurveyService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'surveyquestiontemplates';
    public cloneSurveyQuestion(id: string, body: any): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SurveyService.URL + '/' + id + '/clones', body).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getSurveyQuestionActivities(filter: ActivityFilter): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IActivityLogs>>(SurveyService.URL + '/activities', filter).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
